import EnglishLanguage from '../Languages/EnglishLanguage.json'
import ArabicLanguage from '../Languages/ArabicLanguage.json'
import GermanLanguage from '../Languages/GermanLanguage.json'
import { message, notification } from 'antd'
import { GET } from '../utils/apis'
import moment from 'moment'
import axios from 'axios'
const convertTitle = (val) => val?.charAt(0)?.toUpperCase() + val?.slice(1)


const assignLanguage = (language) => {
    return language === 'english' ? EnglishLanguage :
        language === 'arabic' ? ArabicLanguage :
            GermanLanguage;
}
const successMessage = (desc = 'Successfully Complete!') => {
    return message.success(desc)
}

const infoMessage = (desc = 'Successfully Complete!') => {
    return message.info(desc)
}

const errorMessage = (desc = 'Oops Something Went Wrong!') => {
    return message.error(desc)
}
const errorMessageWithDuration = (desc = 'Oops Something Went Wrong!') => {
    return message.error(desc, [0.8])
}

const warningMessage = (desc = 'Warning!') => {
    return message.warning(desc)
}

const successNotification = (message = 'Successfully Complete!') => {
    return notification.success({ message })
}

const errorNotification = (message = 'Oops Something Went Wrong!') => {
    return notification.error({ message })
}
const imageSizeFromBase64 = (base64) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = base64;
        img.onload = () => {
            const { height, width } = img;
            resolve({ height, width });
        };
    });
};
const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
};

const getBase642 = (img) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(img);
    });
};

const imageSizeFromBase642 = (base64) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = base64;
        img.onload = () => {
            const { height, width } = img;
            resolve({ height, width });
        };
    });
};

const checkSelectOption = (input, option) => option?.children?.toLowerCase().includes(input.toLowerCase().trim())

const strToMoment = (str) => {
    if (str) {
        return moment(str, 'HH:mm')
    } else {
        return null
    }
}

const fetchDataParams = async (ROUTE, action, userId, obj = false) => {
    axios.get(`${ROUTE}/${userId}`)
        .then((res) => {
            const { data } = res
            if (data?.success) {
                if (obj) {
                    action(data?.data || [])
                } else {
                    action(data?.data || {})
                }
            }
            else {
                if (obj) {
                    action([])
                } else {
                    action({})
                }
            }
        })
}


const clanicData = {
    getMyAllServices: (userActions, userId) => fetchDataParams(GET.GET_MY_ALL_SERVICES, userActions.addClanicServices, userId),
    getMyAllDoctors: (userActions, userId) => fetchDataParams(GET.GET_MY_ALL_DOCTORS, userActions.addAllDoctorsUser, userId),
    getMyAllRooms: (userActions, userId) => fetchDataParams(GET.GET_MY_ALL_ROOM, userActions.addAllRooms, userId),
    getAllContactForm: (userActions, userId) => fetchDataParams(GET.GET_CONTACT_DATA, userActions.addAllContactForms, userId),
    all: function (userActions, userId) {
        this.getMyAllServices(userActions, userId)
        this.getMyAllDoctors(userActions, userId)
        this.getMyAllRooms(userActions, userId)
        this.getAllContactForm(userActions, userId)
    }
}

const convertNumber = (num) => `${parseFloat(num)?.toFixed(2)}`

const stringLimiter = (val, limit = 50) => val?.length > limit ? `${val.slice(0, limit)}...` : val

const createInvoicesDataForCsv = async (allInvoices, selectedLanguage) => {
    let invoiceArr = []
    
    for (let invoice of allInvoices) {
        let invoiceObj = {
            name: stringLimiter(invoice?.name || '', 25),
            designName: stringLimiter(invoice?.designName || '', 25),
            email: stringLimiter(invoice?.email || '', 25),
            number: stringLimiter(invoice?.number || '', 25),
            postCode: stringLimiter(invoice?.postCode || '', 25),
            message: stringLimiter(invoice?.message || '', 25),
        };

        invoiceArr.push(invoiceObj)
    }
    return invoiceArr
};

const createInvoicesCsv = async (allInvoices, selectedLanguage) => {
    let arrayData = await createInvoicesDataForCsv(allInvoices, selectedLanguage)
    const flattenObject = (obj, parent = '', res = {}) => {
        for (let key in obj) {
            const propName = parent ? `${parent}.${key}` : key;

            if (Array.isArray(obj[key])) {
                // Handle arrays of objects (for courts, activities, etc.)
                res[propName] = obj[key].map(item => {
                    return Object.keys(item).map(k => `${k}: ${item[k]}`).join('; ');
                }).join(' | '); // Separate array items with a pipe symbol
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                flattenObject(obj[key], propName, res); // Recursive call for nested objects
            } else {
                res[propName] = obj[key];
            }
        }
        return res;
    };

    const convertArrayToCSV = (array) => {
        const csvRows = [];

        // Flatten all objects in the array
        const flattenedArray = array.map(obj => flattenObject(obj));

        // Get the headers (keys from the first flattened object)
        const headers = Object.keys(flattenedArray[0]);
        csvRows.push(headers.join(',')); // join headers with commas

        // Loop through the data and push values as CSV rows
        for (const row of flattenedArray) {
            const values = headers.map(header => {
                const escaped = ('' + row[header]).replace(/"/g, '\\"'); // Escape quotes
                return `"${escaped}"`; // Wrap each value in quotes
            });
            csvRows.push(values.join(','));
        }

        return csvRows.join('\n'); // join rows with new lines
    };

    const csvData = convertArrayToCSV(arrayData);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    // Create a temporary link to download the CSV file
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'invoices.csv'); // Filename for the CSV
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
}

export {
    assignLanguage,
    successMessage,
    infoMessage,
    errorMessage,
    errorMessageWithDuration,
    warningMessage,
    successNotification,
    errorNotification,
    imageSizeFromBase64,
    getBase64,
    imageSizeFromBase642,
    getBase642,
    checkSelectOption,
    strToMoment,
    clanicData,
    convertNumber,
    convertTitle,
    createInvoicesCsv
}